export const TYPE_RGBA = 0;
export const TYPE_CMYK = 1;
export const TYPE_RGB = 2;